import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';

var _4cd5eb00 = function _4cd5eb00() {
  return interopDefault(import('../pages/monitoring.vue'
  /* webpackChunkName: "pages/monitoring" */
  ));
};

var _4b2cdac4 = function _4b2cdac4() {
  return interopDefault(import('../pages/redirect_url.vue'
  /* webpackChunkName: "pages/redirect_url" */
  ));
};

var _2458c032 = function _2458c032() {
  return interopDefault(import('../pages/tools/grid.vue'
  /* webpackChunkName: "pages/tools/grid" */
  ));
};

var _5cfd70be = function _5cfd70be() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "pages/_market/_language/index" */
  ));
};

var _20978067 = function _20978067() {
  return interopDefault(import('../pages/_market/_language/cart/index.vue'
  /* webpackChunkName: "pages/_market/_language/cart/index" */
  ));
};

var _7b884170 = function _7b884170() {
  return interopDefault(import('../pages/_market/_language/help/index.vue'
  /* webpackChunkName: "pages/_market/_language/help/index" */
  ));
};

var _04a6a698 = function _04a6a698() {
  return interopDefault(import('../pages/_market/_language/login/index.vue'
  /* webpackChunkName: "pages/_market/_language/login/index" */
  ));
};

var _60603493 = function _60603493() {
  return interopDefault(import('../pages/_market/_language/lost-password/index.vue'
  /* webpackChunkName: "pages/_market/_language/lost-password/index" */
  ));
};

var _63af9740 = function _63af9740() {
  return interopDefault(import('../pages/_market/_language/reset-password/index.vue'
  /* webpackChunkName: "pages/_market/_language/reset-password/index" */
  ));
};

var _6816f542 = function _6816f542() {
  return interopDefault(import('../pages/_market/_language/signup/index.vue'
  /* webpackChunkName: "pages/_market/_language/signup/index" */
  ));
};

var _9012a038 = function _9012a038() {
  return interopDefault(import('../pages/_market/_language/sitemap/index.vue'
  /* webpackChunkName: "pages/_market/_language/sitemap/index" */
  ));
};

var _3202cd99 = function _3202cd99() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "pages/_market/_language/store-locator/index" */
  ));
};

var _39975752 = function _39975752() {
  return interopDefault(import('../pages/_market/_language/user/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/index" */
  ));
};

var _262936b6 = function _262936b6() {
  return interopDefault(import('../pages/_market/_language/help/confirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/confirm" */
  ));
};

var _c81777bc = function _c81777bc() {
  return interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
  /* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
  ));
};

var _0daf7116 = function _0daf7116() {
  return interopDefault(import('../pages/_market/_language/poc/grid.vue'
  /* webpackChunkName: "pages/_market/_language/poc/grid" */
  ));
};

var _1aa57033 = function _1aa57033() {
  return interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
  /* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
  ));
};

var _66c49180 = function _66c49180() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "pages/_market/_language/s/home-by-me" */
  ));
};

var _76ddd9ec = function _76ddd9ec() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "pages/_market/_language/s/lighting" */
  ));
};

var _018dab3b = function _018dab3b() {
  return interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
  /* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
  ));
};

var _7310d120 = function _7310d120() {
  return interopDefault(import('../pages/_market/_language/t/confirmed.vue'
  /* webpackChunkName: "pages/_market/_language/t/confirmed" */
  ));
};

var _2549c873 = function _2549c873() {
  return interopDefault(import('../pages/_market/_language/t/delivery.vue'
  /* webpackChunkName: "pages/_market/_language/t/delivery" */
  ));
};

var _2630da0c = function _2630da0c() {
  return interopDefault(import('../pages/_market/_language/t/login.vue'
  /* webpackChunkName: "pages/_market/_language/t/login" */
  ));
};

var _3d6b0435 = function _3d6b0435() {
  return interopDefault(import('../pages/_market/_language/t/lost-password.vue'
  /* webpackChunkName: "pages/_market/_language/t/lost-password" */
  ));
};

var _33d87652 = function _33d87652() {
  return interopDefault(import('../pages/_market/_language/t/payment.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment" */
  ));
};

var _0a6aa8ba = function _0a6aa8ba() {
  return interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
  /* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
  ));
};

var _195b7ebe = function _195b7ebe() {
  return interopDefault(import('../pages/_market/_language/t/refused.vue'
  /* webpackChunkName: "pages/_market/_language/t/refused" */
  ));
};

var _07368d52 = function _07368d52() {
  return interopDefault(import('../pages/_market/_language/t/signup.vue'
  /* webpackChunkName: "pages/_market/_language/t/signup" */
  ));
};

var _e7f54794 = function _e7f54794() {
  return interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
  /* webpackChunkName: "pages/_market/_language/user/gift-cards" */
  ));
};

var _40e4b450 = function _40e4b450() {
  return interopDefault(import('../pages/_market/_language/user/orders/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/index" */
  ));
};

var _2a96daa9 = function _2a96daa9() {
  return interopDefault(import('../pages/_market/_language/user/profile.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile" */
  ));
};

var _7054fe6c = function _7054fe6c() {
  return interopDefault(import('../pages/_market/_language/user/profile/index.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/index" */
  ));
};

var _13c2983c = function _13c2983c() {
  return interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
  ));
};

var _383e5426 = function _383e5426() {
  return interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
  ));
};

var _3365f78a = function _3365f78a() {
  return interopDefault(import('../pages/_market/_language/user/profile/FormAddress.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/FormAddress" */
  ));
};

var _43d73471 = function _43d73471() {
  return interopDefault(import('../pages/_market/_language/user/profile/password.vue'
  /* webpackChunkName: "pages/_market/_language/user/profile/password" */
  ));
};

var _5f5a8016 = function _5f5a8016() {
  return interopDefault(import('../pages/_market/_language/user/wishlist.vue'
  /* webpackChunkName: "pages/_market/_language/user/wishlist" */
  ));
};

var _9b12f560 = function _9b12f560() {
  return interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
  ));
};

var _5c7e437d = function _5c7e437d() {
  return interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
  ));
};

var _3a072e6a = function _3a072e6a() {
  return interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/contact/_form" */
  ));
};

var _68ff4dda = function _68ff4dda() {
  return interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
  /* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
  ));
};

var _2b5de1fe = function _2b5de1fe() {
  return interopDefault(import('../pages/_market/_language/help/return/_form.vue'
  /* webpackChunkName: "pages/_market/_language/help/return/_form" */
  ));
};

var _3f7797b6 = function _3f7797b6() {
  return interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
  /* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
  ));
};

var _c2aefc7e = function _c2aefc7e() {
  return interopDefault(import('../pages/_market/_language/c/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/c/_alias" */
  ));
};

var _4cfbea30 = function _4cfbea30() {
  return interopDefault(import('../pages/_market/_language/configurator/_model.vue'
  /* webpackChunkName: "pages/_market/_language/configurator/_model" */
  ));
};

var _526cab88 = function _526cab88() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
  ));
};

var _02ade794 = function _02ade794() {
  return interopDefault(import('../pages/_market/_language/p/_alias.vue'
  /* webpackChunkName: "pages/_market/_language/p/_alias" */
  ));
};

var _36de6d68 = function _36de6d68() {
  return interopDefault(import('../pages/_market/_language/q/_keyword.vue'
  /* webpackChunkName: "pages/_market/_language/q/_keyword" */
  ));
};

var _fd5fd30c = function _fd5fd30c() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
  ));
};

var _d3e9a946 = function _d3e9a946() {
  return interopDefault(import('../pages/_market/_language/index.vue'
  /* webpackChunkName: "" */
  ));
};

var _63bd6b49 = function _63bd6b49() {
  return interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _52a6eaad = function _52a6eaad() {
  return interopDefault(import('../pages/_market/_language/s/lighting.vue'
  /* webpackChunkName: "" */
  ));
};

var _4b34c87e = function _4b34c87e() {
  return interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
  /* webpackChunkName: "" */
  ));
};

var _3cb0debb = function _3cb0debb() {
  return interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
  /* webpackChunkName: "" */
  ));
};

var _4aca05f8 = function _4aca05f8() {
  return interopDefault(import('../pages/_market/_language/store-locator/index.vue'
  /* webpackChunkName: "" */
  ));
};

Vue.use(Router);

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'; // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.

    window.addEventListener('beforeunload', function () {
      window.history.scrollRestoration = 'auto';
    }); // Setting scrollRestoration to manual again when returning to this page.

    window.addEventListener('load', function () {
      window.history.scrollRestoration = 'manual';
    });
  }
}

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  var position = false; // if no children detected and scrollToTop is not explicitly disabled

  if (to.matched.length < 2 && to.matched.every(function (r) {
    return r.components.default.options.scrollToTop !== false;
  })) {
    // scroll to the top of the page
    position = {
      x: 0,
      y: 0
    };
  } else if (to.matched.some(function (r) {
    return r.components.default.options.scrollToTop;
  })) {
    // if one of the children has scrollToTop option set to true
    position = {
      x: 0,
      y: 0
    };
  } // savedPosition is only available for popstate navigations (back button)


  if (savedPosition) {
    position = savedPosition;
  }

  return new Promise(function (resolve) {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', function () {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        var hash = to.hash; // CSS.escape() is not supported with IE and Edge.

        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1));
        }

        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = {
              selector: hash
            };
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
        }
      }

      resolve(position);
    });
  });
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/monitoring",
      component: _4cd5eb00,
      name: "monitoring"
    }, {
      path: "/redirect_url",
      component: _4b2cdac4,
      name: "redirect_url"
    }, {
      path: "/tools/grid",
      component: _2458c032,
      name: "tools-grid"
    }, {
      path: "/:market/:language",
      component: _5cfd70be,
      name: "market-language"
    }, {
      path: "/:market/:language/cart",
      component: _20978067,
      name: "market-language-cart"
    }, {
      path: "/:market/:language/help",
      component: _7b884170,
      name: "market-language-help"
    }, {
      path: "/:market/:language/login",
      component: _04a6a698,
      name: "market-language-login"
    }, {
      path: "/:market/:language/lost-password",
      component: _60603493,
      name: "market-language-lost-password"
    }, {
      path: "/:market/:language/reset-password",
      component: _63af9740,
      name: "market-language-reset-password"
    }, {
      path: "/:market/:language/signup",
      component: _6816f542,
      name: "market-language-signup"
    }, {
      path: "/:market/:language/sitemap",
      component: _9012a038,
      name: "market-language-sitemap"
    }, {
      path: "/:market/:language/store-locator",
      component: _3202cd99,
      name: "market-language-store-locator"
    }, {
      path: "/:market/:language/user",
      component: _39975752,
      name: "market-language-user"
    }, {
      path: "/:market/:language/help/confirm",
      component: _262936b6,
      name: "market-language-help-confirm"
    }, {
      path: "/:market/:language/help/deliveryConfirm",
      component: _c81777bc,
      name: "market-language-help-deliveryConfirm"
    }, {
      path: "/:market/:language/poc/grid",
      component: _0daf7116,
      name: "market-language-poc-grid"
    }, {
      path: "/:market/:language/s/catalogue-luminaires",
      component: _1aa57033,
      name: "market-language-s-catalogue-luminaires"
    }, {
      path: "/:market/:language/s/home-by-me",
      component: _66c49180,
      name: "market-language-s-home-by-me"
    }, {
      path: "/:market/:language/s/lighting",
      component: _76ddd9ec,
      name: "market-language-s-lighting"
    }, {
      path: "/:market/:language/s/sustainable-development",
      component: _018dab3b,
      name: "market-language-s-sustainable-development"
    }, {
      path: "/:market/:language/t/confirmed",
      component: _7310d120,
      name: "market-language-t-confirmed"
    }, {
      path: "/:market/:language/t/delivery",
      component: _2549c873,
      name: "market-language-t-delivery"
    }, {
      path: "/:market/:language/t/login",
      component: _2630da0c,
      name: "market-language-t-login"
    }, {
      path: "/:market/:language/t/lost-password",
      component: _3d6b0435,
      name: "market-language-t-lost-password"
    }, {
      path: "/:market/:language/t/payment",
      component: _33d87652,
      name: "market-language-t-payment"
    }, {
      path: "/:market/:language/t/payment-paypal-pending",
      component: _0a6aa8ba,
      name: "market-language-t-payment-paypal-pending"
    }, {
      path: "/:market/:language/t/refused",
      component: _195b7ebe,
      name: "market-language-t-refused"
    }, {
      path: "/:market/:language/t/signup",
      component: _07368d52,
      name: "market-language-t-signup"
    }, {
      path: "/:market/:language/user/gift-cards",
      component: _e7f54794,
      name: "market-language-user-gift-cards"
    }, {
      path: "/:market/:language/user/orders",
      component: _40e4b450,
      name: "market-language-user-orders"
    }, {
      path: "/:market/:language/user/profile",
      component: _2a96daa9,
      children: [{
        path: "",
        component: _7054fe6c,
        name: "market-language-user-profile"
      }, {
        path: "addresses",
        component: _13c2983c,
        name: "market-language-user-profile-addresses"
      }, {
        path: "alerts",
        component: _383e5426,
        name: "market-language-user-profile-alerts"
      }, {
        path: "FormAddress",
        component: _3365f78a,
        name: "market-language-user-profile-FormAddress"
      }, {
        path: "password",
        component: _43d73471,
        name: "market-language-user-profile-password"
      }]
    }, {
      path: "/:market/:language/user/wishlist",
      component: _5f5a8016,
      name: "market-language-user-wishlist"
    }, {
      path: "/:market/:language/configurator/product/:model?",
      component: _9b12f560,
      name: "market-language-configurator-product-model"
    }, {
      path: "/:market/:language/e/magazine/:slug?",
      component: _5c7e437d,
      name: "market-language-e-magazine-slug"
    }, {
      path: "/:market/:language/help/contact/:form?",
      component: _3a072e6a,
      name: "market-language-help-contact-form"
    }, {
      path: "/:market/:language/help/faq/:answer?",
      component: _68ff4dda,
      name: "market-language-help-faq-answer"
    }, {
      path: "/:market/:language/help/return/:form?",
      component: _2b5de1fe,
      name: "market-language-help-return-form"
    }, {
      path: "/:market/:language/user/orders/:reference?",
      component: _3f7797b6,
      name: "market-language-user-orders-reference"
    }, {
      path: "/:market/:language/c/:alias?",
      component: _c2aefc7e,
      name: "market-language-c-alias"
    }, {
      path: "/:market/:language/configurator/:model?",
      component: _4cfbea30,
      name: "market-language-configurator-model"
    }, {
      path: "/:market/:language/inspirations/:slug?",
      component: _526cab88,
      name: "market-language-inspirations-slug"
    }, {
      path: "/:market/:language/p/:alias?",
      component: _02ade794,
      name: "market-language-p-alias"
    }, {
      path: "/:market/:language/q/:keyword?",
      component: _36de6d68,
      name: "market-language-q-keyword"
    }, {
      path: "/:market/:language/e/:alias?/:slug?",
      component: _fd5fd30c,
      name: "market-language-e-alias-slug"
    }, {
      path: "/",
      component: _d3e9a946,
      name: "market-language-home-fr"
    }, {
      path: "/:market/:language/inspirations*",
      component: _63bd6b49,
      name: "market-language-inspirations-fr"
    }, {
      path: "/:market/:language/inspirationen*",
      component: _63bd6b49,
      name: "market-language-inspirations-de"
    }, {
      path: "/:market/:language/ispirazione*",
      component: _63bd6b49,
      name: "market-language-inspirations-it"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-en"
    }, {
      path: "/:market/:language/inspiration*",
      component: _63bd6b49,
      name: "market-language-inspirations-pt"
    }, {
      path: "/:market/:language/inspiracion*",
      component: _63bd6b49,
      name: "market-language-inspirations-es"
    }, {
      path: "/:market/:language/s/inspiratie*",
      component: _63bd6b49,
      name: "market-language-inspirations-nl"
    }, {
      path: "/:market/:language/s/luminaires*",
      component: _52a6eaad,
      name: "market-language-lighting-fr"
    }, {
      path: "/:market/:language/s/leuchten*",
      component: _52a6eaad,
      name: "market-language-lighting-de"
    }, {
      path: "/:market/:language/s/illuminazioni*",
      component: _52a6eaad,
      name: "market-language-lighting-it"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-en"
    }, {
      path: "/:market/:language/s/lighting*",
      component: _52a6eaad,
      name: "market-language-lighting-pt"
    }, {
      path: "/:market/:language/s/lamparas*",
      component: _52a6eaad,
      name: "market-language-lighting-es"
    }, {
      path: "/:market/:language/s/verlichting*",
      component: _52a6eaad,
      name: "market-language-lighting-nl"
    }, {
      path: "/:market/:language/s/atelier-deco*",
      component: _4b34c87e,
      name: "market-language-home-by-me-fr"
    }, {
      path: "/:market/:language/s/atelier-arredo*",
      component: _4b34c87e,
      name: "market-language-home-by-me-it"
    }, {
      path: "/:market/:language/s/taller-de-decoracion*",
      component: _4b34c87e,
      name: "market-language-home-by-me-es"
    }, {
      path: "/:market/:language/s/dekowerkstatt*",
      component: _4b34c87e,
      name: "market-language-home-by-me-de"
    }, {
      path: "/:market/:language/s/decor-workshop*",
      component: _4b34c87e,
      name: "market-language-home-by-me-en"
    }, {
      path: "/:market/:language/:alias/:slug",
      component: _3cb0debb,
      name: "market-language-editorial"
    }, {
      path: "/:market/:language/magasins/",
      component: _4aca05f8,
      name: "store-locator"
    }],
    fallback: false
  });
}